import type { FaireProductEntity } from "../../entity_types/product";

export const p_hdzw9ze3me: FaireProductEntity = {
  token: "p_hdzw9ze3me",
  type: "product",
  name: "Minor Monuments - Espresso Roast",
  brandToken: "b_3juit7iu0l",
  brandName: "Go Get Em Tiger",
  imageUrl:
    "https://cdn.faire.com/fastly/b88ba6d17127cbbf3dd42e836275c52e4ffced48cb875c62ecf3307371bcedbd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/033cbdc8824caaab883ca76dce58302ec9b2e4d1966ee9c7098931cc3326129c.jpeg",
    "https://cdn.faire.com/fastly/2750800a666fa8179ee044822eb8d602680603702161b4dbae7c9c1c74f433c9.jpeg",
    "https://cdn.faire.com/fastly/b37c774346345416c6cb77f9d7d978de89896697118a7d34adaadd352ccba691.jpeg",
    "https://cdn.faire.com/fastly/87412cabcf6899a2d4701d52f1718209fb30e20dd3668659839ba1fb53d1f12a.jpeg",
    "https://cdn.faire.com/fastly/c94282eaa336e28a6105dc55b8a6dcb936e5e6ea7e27684b9a09b6c36055116a.jpeg",
  ],
  priceDollars: 10,
  description:
    "\nOur signature espresso blend: full of depth and chocolate, tailored to express complexity and comfort in any milk beverage or rise to the occasion as a straight shot.\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:05.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
